'use client';

import React from 'react';
import styles from './Badge.module.css';

function Badge({ children, variant = 'default', className = '', ...props }) {
  const baseStyles = "inline-flex items-center font-medium text-xs px-2 py-0.5 rounded-full whitespace-nowrap";
  
  const variantStyles = {
    default: "bg-blue-500 text-white",
    secondary: "bg-gray-100 text-gray-900 border border-gray-200",
    destructive: "bg-red-500 text-white",
    outline: "border border-gray-300 text-gray-700 bg-transparent"
  };
  
  const finalClassName = `${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`;
  
  return (
    <span className={finalClassName} {...props}>
      {children}
    </span>
  );
}

// Named export for index.js compatibility
export { Badge };
// Default export for backward compatibility
export default Badge;